import { IonIcon } from "@ionic/react";
import { useIndicatorsStore } from "../stores/indicators.store";
import { caretDownOutline, caretUpOutline } from "ionicons/icons";

interface Props {
  symbol: string;
  interval: string;
}

const RSIReading: React.FC<Props> = ({ symbol, interval }) => {
  const rsiReading = useIndicatorsStore(
    state => state.indicators?.[symbol]?.["rsi"]?.[interval || "15m"]?.["14"]
  );
  const rsiTrend =
    useIndicatorsStore(state => state.getDataForSymbol(symbol))?.rsiTrend ||
    "neutral";

  return (
    <>
      {rsiReading && (
        <>
          {rsiTrend === "up" && (
            <IonIcon
              className="text-green-500 text-sm px-2"
              icon={caretUpOutline}
            />
          )}
          {["up", "down"].indexOf(rsiTrend) === -1 && (
            <IonIcon
              className="text-slate-200 text-sm px-2"
              icon={caretUpOutline}
            />
          )}
          {rsiTrend === "down" && (
            <IonIcon
              className="text-red-500 text-sm px-2"
              icon={caretDownOutline}
            />
          )}
          {rsiReading.toFixed(2)}
        </>
      )}
      {!rsiReading && "N/A"}
    </>
  );
};

export default RSIReading;
